import './style.css';
import Navbar from '../../../components/Landing_page_Navbar/index';
import Hero from './components/Hero';
import Capabilities from './components/Capabilities';
import Integrity from './components/Integrity';
import RankingCalculation from './components/RankingCalculation';
import StarTiers from './components/StarTiers';
import StarMeanings from './components/StarMeanings';
import TrustSignals from './components/TrustSignals';
import MarketReviews from './components/MarketReviews';
import QualityStandards from './components/QualityStandards';
import GrowthGuide from './components/GrowthGuide';
import ShowcasePreview from './components/ShowcasePreview';
import Benefits from './components/Benefits';
import StandardCta from './components/StandardCta';
import FinalCta from './components/FinalCta';
import FooterNote from './components/FooterNote';

export default function Showcase() {
  return (
    <>
      <Navbar />
      <div className="sx">
        <Hero />
        <Capabilities />
        <Integrity />
        <RankingCalculation />
        <StarTiers />
        <StarMeanings />
        <TrustSignals />
        <MarketReviews />
        <QualityStandards />
        <GrowthGuide />
        <ShowcasePreview />
        <Benefits />
        <StandardCta />
        <FinalCta />
        <FooterNote />
      </div>
    </>
  );
}
